import React, { useState, useMemo } from 'react';
import {EuiFlexGroup, EuiSpacer, EuiSwitch, EuiFormRow, EuiFlexItem, EuiTitle} from '@elastic/eui';
import { Menu } from '../../../../components/Menus';
import { Action } from '../../../../components/Menus/interface';
import { SelectorTiposContenidoContainer as SelectorTiposContenido } from '../../../../components/Selectores/TiposContenidoUltimoPeriodoCerrado/container';
import { downloadFile } from '../../../../../../shared/utils/download';
import { InformesDetalleAdapter } from '../../../../../../infraestructure/persistence/rest/InformesDetalleAdapter';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';

interface Props {
  año: any;
  reunion: any;
}

export const DescargarPlantillaScreen = (props: Props) => {
  let {  año, reunion } = props;

  let [isConDatos, setIsConDatos] = useState(false);
  let [idTipoContenido, setIdTipoContenido] = useState(undefined);
  let result: any;
  const {resultError, exceptionError} = useNotifications();
  
  const onDescargarPlantilla = async() =>{
    const api = new InformesDetalleAdapter();
    try {
			result = await api.DescargarPlantilla({idTipoContenido: idTipoContenido});
			if(result.data && result.data!=="")
			{
				downloadFile(result.data,'Plantilla_Objetivos.xlsx');
			}else{resultError()}
		} catch (e) {
			let exception = ServerErrorMessage(e);
      exceptionError(exception);
		}
	}

  const onChange = (value: any) => {
    setIdTipoContenido(value);
  }

  const Actions: Action[] = useMemo(()=>[
    {handle:onDescargarPlantilla,text:"Descargar Plantilla",color:"secondary",size:"s", isDisabled: false}
  ],[idTipoContenido]);


  return (
    <>
          <EuiFlexGroup gutterSize="s" alignItems="center" className="wrapperMenuPage">
            {<Menu actions={Actions} className="actions"/>}
          </EuiFlexGroup>
          <EuiSpacer size="m" />
          <EuiFlexGroup gutterSize="s" alignItems="center" className="">
            <EuiFlexItem>
              <EuiFormRow fullWidth >
                <EuiSwitch
                  label="Descargar Plantilla con Datos"
                  checked={isConDatos}
                  onChange={e => setIsConDatos(e.target.checked)}
                  compressed
                />
                </EuiFormRow>
              </EuiFlexItem>
            </EuiFlexGroup>
            <EuiSpacer size="m" />
            <EuiFlexGroup gutterSize="s" alignItems="center" className="">
              <EuiFlexItem>
                <EuiFormRow>
                  <EuiTitle size="s"><h1>{año} - {reunion}</h1></EuiTitle>
                </EuiFormRow>
                <EuiFormRow fullWidth >
                  <SelectorTiposContenido valueOfSelected={idTipoContenido} onChange={(value: any) => onChange(value)} disabled={!isConDatos}/>
                </EuiFormRow>
              </EuiFlexItem>
          </EuiFlexGroup>
          
    </>
  );
};

export default DescargarPlantillaScreen;
